import { EXPRESS_API } from 'configs/api/expressApi';
import { errorToast } from 'lib/components/toasts/error';
import { successToast } from 'lib/components/toasts/success';
import { useMutation, useQueryClient } from 'react-query';
import { uiKitsKeys } from './uiKitsKeys';
import { IUIKitsQueryParams } from './useQueryUIKits';

const duplicateUIKit = async (id: number) => {
  const response = await EXPRESS_API.post(`/superadmin/uikit/${id}/duplicate`);
  return response.data;
};

export const useDuplicateUIKitMutation = (
  params: IUIKitsQueryParams,
  scrollToTop?: () => void
) => {
  const queryClient = useQueryClient();
  return useMutation(duplicateUIKit, {
    mutationKey: uiKitsKeys.duplicate(),
    onSuccess: async () => {
      successToast({ title: 'UI Kit has been successfully duplicated' });
      await queryClient.refetchQueries(uiKitsKeys.list(params));
      if (scrollToTop) {
        scrollToTop();
      }
    },
    onError: () => {
      errorToast({ title: 'Something went wrong duplicating the UI Kit' });
    },
  });
};
